<template>
    <div class="tiger-machine"
        :style="{ 'background-image': 'url('+ bgImage +')'}">
        <!--剩余抽奖次数-->
        <div v-if="tigerMachineStatus && !pointDrawFlag"
            class="draw-chances">
            <div v-if="drawType !=='pointDraw'">
                <div v-if="tips">{{ tips }}</div>
                <div v-else>剩余抽奖次数：<span>{{ drawChances > 99 ? '99+' : drawChances }}</span></div>
            </div>
            <div v-else>{{ pointDrawText }}</div>
        </div>
        <div v-else
            class="draw-chances">
            {{ tigerTopText }}
        </div>
        <!--老虎机抽奖组件-->
        <div class="draw-machine">
            <SlotMachine ref="myLucky"
                width="238px"
                height="110px"
                :prizes="prizes"
                :blocks="blocks"
                :defaultConfig="defaultConfig"
                :slots="slots"
                @end="tigerMachineStop" />
        </div>
        <!--抽奖按钮-->
        <div class="draw-btn"
            @click="drawLotteryHandler">
        </div>
    </div>
</template>

<script>
import wx from 'weixin-js-sdk';
import { BigWheelConstants as BWC } from '../../../common/global-variable';
import { noLoginHandler } from '../../../../../runtime/common-methods/utils';

export default {
  name: 'tigerMachineLottery',
  props: {
    activityInfo: Object,
    awardPool: Array,
    drawChances: Number,
    pointDrawFlag: Boolean,
    activityStatus: Number,
    drawType: String,
    userBase: Object,
    tips: String,
    // 用户的抽奖状态
    drawStatus: {
      type: String,
      default: '',
    },
    // 页面展示文案
    pageDisplayContent: {
      type: String,
      default: '',
    },
    // 弹窗提示语
    tipsMessage: {
      type: String,
      default: '',
    },
    loginType: {
      type: String,
      default: '',
    },
    isLoginFlag: {
      type: Boolean,
      default: false,
    },
    activityUrl: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      // 抽奖插槽，3列
      slots: [
        {
          speed: 10,
        },
        {
          speed: 15,
          direction: -1,
        },
        {
          speed: 20,
        },
      ],
      // 老虎机奖品池
      prizes: [],
      // 背景
      blocks: [
        {
          borderRadius: '10px',
          // background: '#ED3D11',
        },
      ],
      // 老虎机配置
      defaultConfig: {
        rowSpacing: '27px',
        colSpacing: '28px',
      },
      // 老虎机背景图
      bgImage: '',
      // 老虎机状态，TRUE => 可用，FALSE =>不可用
      tigerMachineStatus: true,
      // 老虎机抽奖活动状态：0：未开始，1：进行中，2：已暂停，3：已结束
      notStart: 0,
      running: 1,
      pause: 2,
      over: 3,
      // 中奖奖品信息
      awardParam: {
        // 奖品详情
        awardObj: {},
        // 在奖品池中的位置
        awardIndex: 0,
      },
      activityTypeFlag: '',
    };
  },
  computed: {
    tigerTopText() {
      if (this.activityStatus === this.notStart) {
        this.tigerMachineStatus = false;
        return '活动未开始';
      } else if (this.activityStatus === this.running) {
        this.tigerMachineStatus = true;
        return '登录即可参与幸运大抽奖';
      } else if (this.activityStatus === this.pause) {
        this.tigerMachineStatus = false;
        return '活动已暂停';
      } else {
        this.tigerMachineStatus = false;
        return '活动已结束';
      }
    },
    // 积分抽奖文案
    pointDrawText() {
      if (this.drawStatus === BWC.status.exceedDailyTimes || this.drawStatus === BWC.status.exceedTotalTimes) {
        return this.pageDisplayContent;
      } else {
        return `每次抽奖扣${this.activityInfo.extendConfig.drawPointConsumption}积分`;
      }
    },
  },
  created() {
    this.activityTypeFlag = sessionStorage.getItem('activityTypeFlag') || '1';
    if (this.activityStatus !== this.running) {
      this.tigerMachineStatus = false;
    }
    this.intiData();
  },
  methods: {
    intiData() {
      // 配置老虎机背景图
      const drawWheelUrl = this.activityInfo.drawWheelUrl;
      this.bgImage = this.$utils.getImageUrl(JSON.parse(drawWheelUrl).file);
      // 配置老虎机奖品图片
      this.prizes = [];
      this.awardPool.forEach((item) => {
        const prizeItem = {
          // background: '#6EAE7B',
          borderRadius: '10px',
          imgs: [
            {
              height: '50px',
              width: '50px',
              top: '5px',
              src: '',
            },
          ],
        };
        if (item.imgUrl) {
          prizeItem.imgs[0].src = item.imgUrl;
        } else {
          prizeItem.imgs[0].src = require('static/runtime/images/magic/award/zp_zjzl.png');
        }
        this.prizes.push(prizeItem);
      });
    },
    // 抽奖点击事件处理
    drawLotteryHandler() {
      console.log('tigerMachineLottery', this.isLoginFlag);
      // 未登录处理，暂时限制在微信场景
      if (!this.isLoginFlag && (this.loginType === 'wechat' || this.loginType === 'Alipay')) {
        noLoginHandler(this.loginType, this.activityUrl);
        return;
      }
      if (this.tigerMachineStatus && !this.pointDrawFlag) {
        if (this.drawChances > 0) {
          // 抛出抽奖事件
          this.$emit('startTigerMachine');
        } else if (this.drawType === 'pointDraw') {
          let message = '积分不足';
          if (this.drawStatus === BWC.status.exceedDailyTimes || this.drawStatus === BWC.status.exceedTotalTimes) {
            message = this.tipsMessage || '';
          }
          this.$emit('noChance', message);
        } else {
          this.$emit('noChance');
        }
      } else if (this.pointDrawFlag) {
        this.$utils.tips.message('warning', '登录后开始抽奖哦！');
      } else {
        this.$utils.tips.message('warning', this.tigerTopText);
      }
    },
    // 抽奖
    drawLottery() {
      this.$refs.myLucky.play();
    },
    // 抽奖结果展示
    displayDrawResult(index, obj) {
      const goodsType = obj.goodsType;
      // 三个插槽列要显示的图片
      const first = index;
      let second = index;
      let three = index;
      // 奖品池数组长度一半
      const halfLen = Math.ceil(this.awardPool.length / 2);
      // 为中奖，则显示结果为随机图片
      if (goodsType === '0') {
        second = Math.ceil(Math.random() * halfLen);
        three = Math.ceil(Math.random() * halfLen + halfLen);
      }
      const res = [first, second, three];
      this.$refs.myLucky.stop(res);

      this.awardParam.awardObj = obj;
      this.awardParam.awardIndex = index;
    },
    // 抽奖结束回调
    tigerMachineStop() {
      console.log('tigerMachineStop');
      // 抛出抽奖结束事件
      this.$emit('endTigerMachine', this.awardParam);
    },
  },
};
</script>
<style lang="scss" scoped>
.tiger-machine {
  width: 350px;
  height: 331px;
  padding-top: 10px;
  margin: 0 auto;
  background-size: 100% 100%;

  .draw-chances {
    font-family: HYQiHei-FZS;
    font-size: 16px;
    color: #ffffff;
    text-align: center;
    font-weight: 400;
  }

  .draw-machine {
    width: 238px;
    height: 110px;
    margin-left: 56px;
    border-radius: 10px;
    margin-top: 48px;
  }

  .draw-btn {
    width: 100px;
    height: 50px;
    margin-left: 127px;
    margin-top: 25px;
    border-radius: 40px;
  }
}
</style>



// WEBPACK FOOTER //
// src/page/vibrantRubikCube/runtime/lucky-draw/lucky-draw-page/roulette-koi/components/tigerMachineLottery.vue